import { useRef, useState } from 'react';
import NewsSubmissionForm from '../NewsSubmissionForm';
import SourceCategoryForm from '../SourceCategoryForm/SourceCategoryForm';
import './newsadmin.scss';

const CreateArticle = () => {
  const [isSubmitSuccessful, setSubmitSuccess] = useState(false);
  const formRef = useRef();
  return (
    <div className="createArticle">
      <NewsSubmissionForm
        closedText={'Close'}
        submitText={'Publish'}
        _handleClose={() => {
          setSubmitSuccess(false);
        }}
        isSubmitSuccessful={isSubmitSuccessful}
        setSubmitSuccess={setSubmitSuccess}
        fillDetails={false}
        requirementFormClass={'herorequirementFormClass newsForm'}
        formType="customer"
        formRef={formRef}
      />
    </div>
  );
};

export default CreateArticle;
